import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js';
import FormInput from '../../Fields/FormInput.js';
import FormDatePicker from '../../Fields/FormDatePicker.js';
import FormSelect from '../../Fields/FormSelect.js';
import NamezzzTelNum from '../../Fields/NamezzzTelNum.js';
import FormCreatePassword from '../../Fields/FormCreatePassword.js';
import FormCheckbox from '../../Fields/FormCheckbox.js';
import HtmlLegendTitle from '../../Fields/HtmlLegendTitle.js';

import { getPersonalia, getNewPersonalia, postPersonalia, postCompleteRegistrant } from '../../Api/UserActions.js';
import { getLanguages, getCountries, getMedia, getJobOrgPub } from '../../Api/Namezzz.js';
import { postRegister, postLogin } from '../../Api/Register.js';
import { getTranslation } from '../../Utilities/GetTranslation.js';
import { isEmpty } from '../../Utilities/JsonFunctions.js';
import { registerIndeed } from '../../Utilities/SnsFunctions.js';

declare var globalSns;

class PersonalData extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showValidation: false,
            validationErrors: [],
            isValid: false,
            setAgreeTerms: false
        }

        this.handleValueChange = this.handleValueChange.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        if (this.props.authenticated) {
            var jobId = (this.props.job) ? globalSns.jobId : -1;
            getPersonalia(globalSns.languageId, jobId, (data) => {
                this.loadPersonData(data);
            });
        } else {
            getNewPersonalia((data) => {
                this.loadPersonData(data);
            });
        }
        
        getLanguages(globalSns.languageId, false, (data) => {
            this.setState({
                languages: data
            });
        });
        getLanguages(globalSns.languageId, true, (data) => {
            this.setState({
                languageslimited: data
            });
        });
        getCountries(globalSns.languageId, (data) => {
            this.setState({
                countries: data
            });
        });

        this.loadJobData();
    }

    saveData(data) {
        if (this.state.showMedium && (data.seqMed !== globalSns.jobSiteId)) {
            data.seqMedOrg = -1;
        }

        return new Promise(ok => {
            var jobId = (this.props.job) ? globalSns.jobId : -1;
            postPersonalia(data, jobId, globalSns.languageId, (newData, success) => {
                
                if (this.props.job && this.props.job.isBusinessRegistration) {
                    postCompleteRegistrant(jobId, globalSns.languageId, () => {});
                }

                if (success) {
                    registerIndeed();
                } else {
                    this.showMessage(newData.responseJSON == null ? "err_general" : newData.responseJSON.message);
                }

                ok(success);
            });
        });
    }

    loadPersonData(data) {
        if (data == null) {
            this.showMessage("err_general");
            return;
        }

        var showMedium = true;

        if ((globalSns.mediumId != null) && (data.seqMed === 0 || data.seqMedOrg === 0)) {
            data.seqMed = globalSns.jobSiteId;
            data.seqMedOrg = globalSns.mediumId;
            showMedium = false;
        }

        if (data.seqMed > 0 || data.seqMedOrg > 0) {
            showMedium = false;
        }

        this.setState({
            showMedium: showMedium,
            data: data
        });
    }

    loadJobData() {
        if (this.props.job != null && !this.props.job.hasMediaFreeText) {
            getMedia(globalSns.languageId, (data) => {
                this.setState({
                    media: data
                });
            });
            if (globalSns.jobId > 0) {
                getJobOrgPub(globalSns.languageId, globalSns.jobId, (data) => {
                    this.setState({
                        jobOrgPub: data
                    });
                });
            }
        }
    }

    registerUser() {
        return new Promise(ok => {

            if (!this.state.passwordvalid) {
                ok(false);
                return;
            }

            var birthdayValues = this.state.data.birthday.split("/");            
            var birthdayValue = birthdayValues[0] + "/" + birthdayValues[1] + "/" + birthdayValues[2];
            if (globalSns.languageId === 3) {
                birthdayValue = birthdayValues[1] + "/" + birthdayValues[0] + "/" + birthdayValues[2];
            }

            postRegister(this.state.data.strNam,
                this.state.data.strFirstNam,
                birthdayValue,
                this.state.data.sex,
                this.state.data.mail,
                this.state.password,
                this.state.data.seqLangFill,
                (data, success) => {
                    if (success) {
                        postLogin(this.state.data.mail, this.state.password, () => {
                            ok(true);
                            this.props.onAuthenticated();
                        });
                    } else {
                        this.showMessage(data.responseJSON == null ? "err_general" : data.responseJSON.message);
                        ok(false);
                    }
                }
            );
        });
    }

    async isValidated() {
        if (this.state.data == null || this.state.processing) {
            return false;
        }

        this.setState({
            showValidation: true,
            processing: true
        })

        var rules = this.validationRules();
        
        for (var rule in rules) {
            
            var value = this.state.data[rule];
            
            // required ?
            if (rules[rule].required) {
                if (typeof value === "string" && (isEmpty(value) || ["-1","##"].indexOf(value) > -1)) {
                    this.setState({processing: false});
                    return false;
                } else if (value === -1) {
                    this.setState({processing: false});
                    return false;
                }
            }

            // extra validation rules ?
            if (typeof rules[rule].validation !== "undefined" && (rules[rule].validation(value) || null) !== null) {
                this.setState({processing: false});
                return false;
            }
        }

        if (!this.props.authenticated) {
            // Does the new user agree to the terms ?
            if (!this.state.setAgreeTerms) {
                this.setState({processing: false});
                return false;
            }

            // Try to register user first
            var ok = await this.registerUser();
            if (!ok) {
                this.setState({processing: false});
                return false;
            }
        }

        var saved = this.saveData(this.state.data);

        this.setState({processing: false});
        return saved;
    }

    validationRules() {
        return {
            "strFirstNam" : {
                required: true
            },
            "strNam" : {
                required: true
            },
            "birthday" : {
                required: true,
                validation: function(val) {

                    if (val == null) {
                        val = "";
                    }
                    
                    var values = val.split("/");
                    if (values.length !== 3 || values[2].length !== 4) {
                        return getTranslation("sns.general.dateformat");
                    }
                    
                    var valToParse = values[1] + "/" + values[0] + "/" + values[2];
                    if (globalSns.languageId === 3) {
                        valToParse = values[0] + "/" + values[1] + "/" + values[2];
                    }

                    var birthday = Date.parse(valToParse);

                    if (isNaN(birthday)) {
                        return getTranslation("sns.general.dateformat");
                    }

                    if (birthday > new Date().getTime()) {
                        return getTranslation("sns.general.dateformat");
                    }
                }
            },
            "seqLangNat" : {
                required: true,
                validation: function(val) {
                    if (val === 0 || val === "0") {
                        return getTranslation("basicform.erroremptyvalue");
                    }
                }
            },
            "seqLangFill" : {
                required: true,
                validation: function(val) {
                    if (val === 0 || val === "0") {
                        return getTranslation("basicform.erroremptyvalue");
                    }
                }
            },
            "sex" : {
                required: true
            },
            "seqNat" : {
                required: true,
                validation: function(val) {
                    if (val === 0 || val === "0") {
                        return getTranslation("basicform.erroremptyvalue");
                    }
                }                
            },
            "seqCountry" : {
                required: true,
                validation: function(val) {
                    if (val === 0 || val === "0") {
                        return getTranslation("basicform.erroremptyvalue");
                    }
                }                
            },
            "straat" : {
                required: true
            },
            "adres" : {
                required: true
            },
            "postcode" : {
                required: true
            },
            "gemeente" : {
                required: true
            },
            "mail" : {
                required: true,
                validation: function(val) {
                    if (!/^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/.test(val)) {
                        return getTranslation("emailinput.validationerror");
                    }
                }
            },
            "gsm" : {
                required: true,
                validation: function(val) {
                    if (isEmpty(val) || val === "##") {
                        return;
                    }

                    var nrs = val.split("#");
                    for (let nr of nrs) {
                        if (nr.length === 0) {
                            return getTranslation("sns.webparts.personalia.telerror");
                        }
                    }
                }
            },
            "phone" : {
                required: false,
                validation: function(val) {
                    if (isEmpty(val) || val === "##") {
                        return;
                    }

                    var nrs = val.split("#");
                    for (let nr of nrs) {
                        if (nr.length === 0) {
                            return getTranslation("sns.webparts.personalia.telerror");
                        }
                    }
                }
            }
        }
    }

    handleValidation(name) {
        var rules = this.validationRules();
        var value = this.state.data[name];

        if (rules[name] == null) {
            return null;
        }

        if (rules[name].required) {
            if (typeof value === "string" && (isEmpty(value) || ["-1","##"].indexOf(value) > -1)) {
                return getTranslation("basicform.erroremptyvalue");
            } else if (value === -1) {
                return getTranslation("basicform.erroremptyvalue");
            }
        }

        if (typeof rules[name].validation === "undefined") {
            return true;
        }

        return rules[name].validation(value);
    }

    onChangePassword(e, password, valid) {
        this.setState({
            password: password,
            passwordvalid: valid
        })
        
    }

    onSelectChange(e) {
        this.setState({
            setAgreeTerms: e.target.checked
        });
    }

    onEdit(e) {
        if (this.props.onEdit == null) {
            return;
        }
        this.props.onEdit(e);
    }

    handleValueChange(e) {
        var value = (e.target.type === "select-one") ? parseInt(e.target.value, 10) : e.target.value;
        this.setState({
            data: update(this.state.data, {[e.target.id]: {$set: value}})
        });         
    }

    showMessage(errCode) {
        // show error
        switch (errCode) {
            case "err_userid_bestaat":
            case "login_contact_sns":
                this.setState({
                    errorMessage: "sns.webparts.personaldata.error.userdata"
                });
                break;
            default:
                this.setState({
                    errorMessage: "sns.webparts.personaldata.error"
                });
        }
        
        window.location.hash = "errorlabel";
    }

    render() {
        if (this.state.data == null || this.state.languages == null || this.state.languageslimited == null || this.state.countries == null ||
         (this.props.job != null && ((!this.props.job.hasMediaFreeText) && (this.state.media == null && (globalSns.jobId === 0 || this.state.jobOrgPub == null))))) {
            return (
                <div>
                    { (this.state.errorMessage) ?
                        <span id="errorlabel" className="ErrorLabel">{getTranslation(this.state.errorMessage)}</span> : <Loading/>
                    }
                </div>
            );
        }

        return (
            <div>
                {
                    this.props.readonly ? "" : <p><em>{getTranslation("sns.webparts.personalia.sub")}</em></p>
                }
                {
                    (this.state.errorMessage) ?
                        <span id="errorlabel" className="ErrorLabel">{getTranslation(this.state.errorMessage)}</span> : ""
                }
                <div className="printblock">
                    <HtmlLegendTitle title={getTranslation("sns.webparts.personalia.cat-persoonsgegevens")} 
                        readonly={!this.props.showEdit} onClick={this.onEdit} />                     

                    <FormInput id="strNam"
                        text={getTranslation("sns.webparts.personalia.familienaam")}
                        explanation={getTranslation("sns.webparts.personalia.familienaam.info")}
                        required={true}
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("strNam")} 
                        autocomplete="family-name"
                        value={this.state.data.strNam} 
                        onChange={this.handleValueChange} />
                    <FormInput id="strFirstNam" 
                        text={getTranslation("sns.webparts.personalia.voornaam")}
                        required={true}
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("strFirstNam")} 
                        autocomplete="given-name"
                        value={this.state.data.strFirstNam} 
                        onChange={this.handleValueChange} />
                    <FormDatePicker id="birthday" 
                        text={getTranslation("sns.webparts.personalia.geboortedatum")}
                        tooltip={getTranslation("sns.webparts.personalia.geboortedatum.tooltip")}
                        explanation={getTranslation("sns.webparts.personalia.geboortedatum.info")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("birthday")} 
                        autocomplete="bday"
                        value={this.state.data.birthday} 
                        onChange={this.handleValueChange} />
                    <FormSelect id="seqLangNat"
                        text={getTranslation("sns.webparts.personalia.moedertaal")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("seqLangNat")}
                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                        data={this.state.languages}
                        value={this.state.data.seqLangNat}
                        onChange={this.handleValueChange} />
                    <FormSelect id="seqLangFill"
                        text={getTranslation("sns.webparts.personalia.communicatie")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("seqLangFill")} 
                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                        data={this.state.languageslimited}
                        value={this.state.data.seqLangFill}
                        onChange={this.handleValueChange} />     
                    <FormSelect id="sex"
                        text={getTranslation("sns.webparts.personalia.geslacht")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("sex")} 
                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                        data={[{key: 1, value: getTranslation("sns.webparts.personalia.geslacht.man")}, {key: 2, value: getTranslation("sns.webparts.personalia.geslacht.vrouw")}]}
                        value={this.state.data.sex}
                        onChange={this.handleValueChange} />    
                    <FormSelect id="seqNat"
                        text={getTranslation("sns.webparts.personalia.nationaliteit")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("seqNat")}
                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                        data={this.state.countries}
                        value={this.state.data.seqNat}
                        onChange={this.handleValueChange} />  
                </div>             
                <div className="printblock">
                    <HtmlLegendTitle title={getTranslation("sns.webparts.personalia.cat-priveadres")} 
                        readonly={!this.props.showEdit} onClick={this.onEdit} />

                    <FormSelect id="seqCountry"
                        text={getTranslation("sns.webparts.personalia.land")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("seqCountry")}
                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                        data={this.state.countries}
                        value={this.state.data.seqCountry}
                        onChange={this.handleValueChange} /> 
                    <FormInput id="straat" 
                        text={getTranslation("sns.webparts.personalia.adres")}
                        required={true}
                        readonly={this.props.readonly} 
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("straat")} 
                        autocomplete="address-line1"
                        value={this.state.data.straat} 
                        onChange={this.handleValueChange} />                    
                    <FormInput id="postcode" 
                        text={getTranslation("sns.webparts.personalia.postcode")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("postcode")} 
                        autocomplete="postal-code"
                        value={this.state.data.postcode} 
                        onChange={this.handleValueChange} />
                    <FormInput id="gemeente" 
                        text={getTranslation("sns.webparts.personalia.gemeente")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("gemeente")} 
                        autocomplete="address-level2"
                        value={this.state.data.gemeente} 
                        onChange={this.handleValueChange} />                    
                </div>             
                <div className="printblock">
                    <HtmlLegendTitle title={getTranslation("sns.webparts.personalia.cat-contact")} 
                        readonly={!this.props.showEdit} onClick={this.onEdit} />

                    <FormInput id="mail" 
                        text={getTranslation("sns.webparts.personalia.email")}
                        required={true} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("mail")} 
                        autocomplete="email"
                        value={this.state.data.mail} 
                        onChange={this.handleValueChange} />
                    <NamezzzTelNum id="gsm"
                        text={getTranslation("sns.webparts.personalia.gsm")}
                        explanation={getTranslation("sns.webparts.personalia.gsm.info")}
                        required={true}
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("gsm")}
                        autocomplete={true}
                        value={this.state.data.gsm} 
                        onChange={this.handleValueChange} />
                    <NamezzzTelNum id="phone"
                        text={getTranslation("sns.webparts.personalia.tel")}
                        explanation={getTranslation("sns.webparts.personalia.tel.info")}
                        required={false}
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("phone")} 
                        value={this.state.data.phone} 
                        onChange={this.handleValueChange} />
                    <FormInput id="linkedIn" 
                        text={getTranslation("sns.webparts.personalia.linkedin")}
                        required={false} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("linkedIn")} 
                        value={this.state.data.linkedIn} 
                        onChange={this.handleValueChange} />
                    <FormInput id="skype" 
                        text={getTranslation("sns.webparts.personalia.skype")}
                        required={false} 
                        readonly={this.props.readonly}
                        showValidation={this.state.showValidation}
                        validationText={this.handleValidation("skype")} 
                        value={this.state.data.skype} 
                        onChange={this.handleValueChange} />
                    {
                        (this.props.job != null) ?
                            (this.props.job.hasMediaFreeText) ?
                                <FormInput id="whereHeardOfOther" 
                                    text={getTranslation("sns.webparts.personalia.whereheardof")}
                                    required={false} 
                                    readonly={this.props.readonly}
                                    showValidation={this.state.showValidation}
                                    validationText={this.handleValidation("whereHeardOfOther")} 
                                    value={this.state.data.whereHeardOfOther} 
                                    onChange={this.handleValueChange} /> :
                                (this.state.showMedium) ?
                                    <div>
                                        <FormSelect id="seqMed"
                                            text={getTranslation("sns.webparts.personalia.medium")}
                                            required={false} 
                                            readonly={this.props.readonly}
                                            showValidation={this.state.showValidation}
                                            validationText={this.handleValidation("seqMed")}
                                            emptyValue={getTranslation("sns.general.ddlnovalue")}
                                            data={this.state.media}
                                            value={this.state.data.seqMed}
                                            onChange={this.handleValueChange} /> 
                                            {
                                                (globalSns.jobId > 0 && this.state.data.seqMed === globalSns.jobSiteId && this.state.jobOrgPub.length > 0) ?
                                                    <FormSelect id="seqMedOrg"
                                                        text={getTranslation("sns.webparts.personalia.jobsite")}
                                                        required={false} 
                                                        readonly={this.props.readonly}
                                                        showValidation={this.state.showValidation}
                                                        validationText={this.handleValidation("seqMedOrg")}
                                                        emptyValue={getTranslation("sns.general.ddlnovalue")}
                                                        data={this.state.jobOrgPub}
                                                        value={this.state.data.seqMedOrg}
                                                        onChange={this.handleValueChange} /> : ""
                                            }
                                        </div> : ""
                                : ""
                    }                    
                </div>                    
                {
                    (!this.props.authenticated) ?
                        <div>
                            <FormCreatePassword
                                showValidation={this.state.showValidation}
                                onChange={this.onChangePassword} /> 
                            <FormCheckbox id="agree"
                                text={getTranslation("sns.webparts.confirmation.terms")}
                                link={globalSns.jobConditionsUrl}
                                required={true}
                                showValidation={this.state.showValidation}
                                validationText={(this.state.setAgreeTerms) ? "" : getTranslation("basicform.erroremptyvalue")}
                                value={this.state.setAgreeTerms}
                                onChange={this.onSelectChange} />
                        </div> : ""
                }
            </div>
        );
    }
}

export default PersonalData;


// WEBPACK FOOTER //
// ./src/Components/Tabs/PersonalData.js